export class HrPerDisabilityKey {
    private static readonly keyPrefix = 'hrPerDisability';
    public static title = `${HrPerDisabilityKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerDisabilityKey.keyPrefix}.pageHeader`;
    public static objectConnect = `${HrPerDisabilityKey.keyPrefix}.objectConnect`;
    public static nameSurname = `${HrPerDisabilityKey.keyPrefix}.nameSurname`;
    public static disabilityLevel = `${HrPerDisabilityKey.keyPrefix}.disabilityLevel`;
    public static disabilityPercentage = `${HrPerDisabilityKey.keyPrefix}.disabilityPercentage`;
    public static disabilityLimbRightLeft = `${HrPerDisabilityKey.keyPrefix}.disabilityLimbRightLeft`;
    public static disabilityLimb = `${HrPerDisabilityKey.keyPrefix}.disabilityLimb`;
    public static enumPerDisabilityLimbRightLeft = `${HrPerDisabilityKey.keyPrefix}.enumPerDisabilityLimbRightLeft`;
    public static disabilityInfo = `${HrPerDisabilityKey.keyPrefix}.disabilityInfo`;
    public static speacialSituType = `${HrPerDisabilityKey.keyPrefix}.speacialSituType`;
}
